"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var focus_trap_react_1 = __importDefault(require("focus-trap-react"));
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var zIndex_1 = require("../../styles/theme/zIndex");
var Portal_1 = require("../Portal");
var FadeTransition_1 = require("../Transition/FadeTransition");
var ModalBackdrop_1 = require("./ModalBackdrop");
var ModalContainer_1 = require("./ModalContainer");
function Modal(props) {
    var open = props.open, size = props.size, closeOnBackdropClick = props.closeOnBackdropClick, children = props.children, containerRef = props.containerRef, style = props.style, onClose = props.onClose, title = props.title, subtitle = props.subtitle, header = props.header, depthLevel = props.depthLevel, manageOverflow = props.manageOverflow, rest = __rest(props, ["open", "size", "closeOnBackdropClick", "children", "containerRef", "style", "onClose", "title", "subtitle", "header", "depthLevel", "manageOverflow"]);
    var _a = styles_1.useStyles(createStyles, depthLevel), classes = _a.classes, css = _a.css;
    // Kill body scroll when opened
    react_1.useEffect(function () {
        if (manageOverflow) {
            if (open) {
                document.body.classList.add(classes.bodyWhenOpened);
            }
            else {
                document.body.classList.remove(classes.bodyWhenOpened);
            }
            return function () { return document.body.classList.remove(classes.bodyWhenOpened); };
        }
    }, [open, classes.bodyWhenOpened, manageOverflow]);
    react_1.useEffect(function () {
        // Attach "Escape" to close modal
        var handleKeyDown = function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        if (open) {
            document.addEventListener('keydown', handleKeyDown);
        }
        else {
            document.removeEventListener('keydown', handleKeyDown);
        }
        return function () { return document.removeEventListener('keydown', handleKeyDown); };
    }, [open, onClose]);
    return (react_1.default.createElement(FadeTransition_1.FadeTransition, { in: open }, function (_a) {
        var className = _a.className;
        return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(Portal_1.Portal, null,
            react_1.default.createElement(focus_trap_react_1.default, null,
                react_1.default.createElement("div", { className: className },
                    react_1.default.createElement("div", { className: classes.modal },
                        react_1.default.createElement(ModalContainer_1.ModalContainer, __assign({ ref: containerRef, title: title, subtitle: subtitle, header: header, style: css(classes.container, classes[size], style), onClose: onClose }, rest), children)),
                    react_1.default.createElement(ModalBackdrop_1.ModalBackdrop, { depthLevel: depthLevel, onClick: closeOnBackdropClick ? onClose : undefined })))))));
    }));
}
exports.Modal = Modal;
Modal.defaultProps = {
    size: 'large',
    closeOnBackdropClick: true,
    depthLevel: 1,
    manageOverflow: true,
};
var createStyles = function (theme, depthLevel) { return ({
    modal: {
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100%',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: zIndex_1.zIndexLevel[depthLevel].modalContainer,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
    },
    container: {
        maxHeight: '80vh',
        overflow: 'auto',
    },
    bodyWhenOpened: {
        overflow: 'hidden',
    },
    large: { width: 900 },
    small: { width: 520 },
    auto: { maxWidth: '100%' },
}); };
//# sourceMappingURL=Modal.js.map